import { any, arrayOf, func, string } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

function BulkToggleControls({
  entities,
  activeEntities,
  onToggleAll,
  toggleAllOnLabel,
  toggleAllOffLabel,
}) {
  return (
    <>
      <Button
        type="button"
        color="link"
        className="pr-1"
        onClick={() => onToggleAll(true)}
        disabled={activeEntities.length === entities.length}
      >
        {toggleAllOnLabel}
      </Button>
      |
      <Button
        type="button"
        color="link"
        className="pl-1"
        onClick={() => onToggleAll(false)}
        disabled={activeEntities.length === 0}
      >
        {toggleAllOffLabel}
      </Button>
    </>
  );
}

BulkToggleControls.propTypes = {
  entities: arrayOf(any.isRequired),
  activeEntities: arrayOf(any.isRequired),
  onToggleAll: func.isRequired,
  toggleAllOnLabel: string,
  toggleAllOffLabel: string,
};

BulkToggleControls.defaultProps = {
  entities: [],
  activeEntities: [],
  toggleAllOnLabel: 'Select all',
  toggleAllOffLabel: 'Deselect all',
};

export default BulkToggleControls;
